module.exports = __webpack_public_path__ + "assets/documentation.879aee2c.svg";